import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import NotreMission from "./sections/NotreMission";
import WhyChooseUs from "./sections/WhyChooseUs";
import WhyThisIntensive from "./sections/WhyThisIntensive";
import IndustriesServed from "./sections/IndustriesServed";
import ArchitecturalPrecision from "./sections/ArchitecturalPrecision";
import PremiumServices from "./sections/PremiumServices";
import GlobalPackagingLandscape from "./sections/GlobalPackagingLandscape";
import OrganizationalStructure from "./sections/OrganizationalStructure";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <NotreMission />
      <WhyChooseUs />
      <WhyThisIntensive />
      <IndustriesServed />
      <ArchitecturalPrecision />
      <PremiumServices />
      <GlobalPackagingLandscape />
      <OrganizationalStructure />
      <Footer />
    </div>;
}